<template>
  <form @submit.prevent="submitFormData" novalidate>
    <div class="row">
      <div class="col-12">
        <BaseInput
            v-model="formData.groupTitle"
            label="Titel des Dokuments"
            :required=true
            :validation="v$.groupTitle"
            :messages="v$.groupTitle.required.$message"/>
      </div>
    </div>

    <div class="form-buttons-w text-center">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup lang="ts">
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, defineEmits, defineProps, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute, useRouter} from 'vue-router';
import useVuelidate from '@vuelidate/core';
import BaseInput from "@/components/base/BaseInput.vue";
import {requiredRule} from "@/shared/validators/validationRules";
import SaveButton from "@/components/button/SaveButton.vue";
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";

const {t} = useI18n();
const route = useRoute();
const unemployedId = +(route.params.unemployedId || route.params.id);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const isSubmitting = ref(false);
const isLoaded = ref(false);

const props = defineProps({
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  documentGroupUuid: {
    type: String,
    required: false,
    default: '',
  },
  selectedGroupTitle: {
    type: String,
    required: false,
    default: '',
  },
});

const formData = ref<any>({
  groupTitle: "",
});

watch(
    () => props.selectedGroupTitle,
    (title) => {
      if (title) {
        formData.value.groupTitle = title;
      }
    },
    { immediate: true }
);

const rules = computed(() => {
  return {
    groupTitle: requiredRule(t),
  };
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitFormData() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.unemployedId = unemployedId;

    if (props.documentGroupUuid) {
      await unemployedPrivateCoachingService.editDigitalDocuments(formData.value, props.documentGroupUuid);
    } else {
      await unemployedPrivateCoachingService.postDigitalDocuments(formData.value);
    }

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  CloseToast()
  isLoaded.value = true;
});
</script>

<style scoped>
</style>

